import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from "../../constant";
import axios from "axios";

/**
 * Fetch Category Products    
 */
export const fetchCategoryProducts = createAsyncThunk('category/fetchCategoryProducts', async (category, { rejectWithValue }) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/${category}`, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });
        return { category, products: res.data };

    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage);
    }
});


/**
 * Fetch All Categories    
 */
export const fetchAllCategories = createAsyncThunk('category/fetchAllCategories', async (_, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + '/categories', {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET
            }
        });
        return res.data;
    } catch (error) {
        const errorMessage = error.response ? error.response.data : error.message;
        return rejectWithValue(errorMessage); 
    }
});
